var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSort(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5045 17.5C13.1127 17.5 12.795 17.1642 12.795 16.75L12.795 2.75C12.795 2.33579 13.1127 2 13.5045 2C13.8963 2 14.2139 2.33579 14.2139 2.75L14.2139 16.75C14.2139 17.1642 13.8963 17.5 13.5045 17.5Z",
    fill: "#A0A1A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.012 17.7805C13.7349 18.0732 13.2858 18.0732 13.0088 17.7803L9.20781 14.5607C8.93075 14.2678 8.93075 13.7929 9.20781 13.5C9.48487 13.2071 9.93407 13.2071 10.2111 13.5L13.5106 16.1895L16.7184 13.4997C16.9956 13.2069 17.4448 13.207 17.7218 13.5C17.9988 13.793 17.9987 14.2678 17.7215 14.5607L14.012 17.7805Z",
    fill: "#A0A1A9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.42497 2.5C6.81679 2.5 7.13443 2.83579 7.13443 3.25L7.13443 17.25C7.13443 17.6642 6.81679 18 6.42496 18C6.03314 18 5.7155 17.6642 5.7155 17.25L5.71551 3.25C5.71551 2.83579 6.03314 2.5 6.42497 2.5Z",
    fill: "#5D5E66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.91743 2.21954C6.19451 1.92677 6.64363 1.92683 6.92064 2.21967L10.7216 5.43934C10.9987 5.73223 10.9987 6.20711 10.7216 6.5C10.4446 6.79289 9.99537 6.79289 9.71831 6.5L6.41885 3.81053L3.211 6.50026C2.93387 6.79308 2.48467 6.79297 2.20767 6.5C1.93068 6.20704 1.93079 5.73216 2.20792 5.43934L5.91743 2.21954Z",
    fill: "#5D5E66"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.7a2119e9.svg";
export { ForwardRef as ReactComponent };